import { jsxs as p, jsx as u } from "react/jsx-runtime";
import x from "next/link.js";
import { tv as d } from "tailwind-variants";
import v from "./Bubble.js";
const a = d({
  base: [
    "flex",
    "font-secondary",
    "items-center",
    "gap-2",
    "p-0",
    "relative",
    "whitespace-nowrap",
    "after:bg-rose-600",
    "after:bottom-[-3px]",
    "after:h-[2px]",
    "after:left-0",
    "after:absolute",
    "after:w-full",
    "after:transition-transform",
    "after:transform-origin-center",
    "after:scale-x-0"
  ],
  variants: {
    isUnderline: {
      true: ["after:scale-x-100"]
    },
    level: {
      primary: ["font-bold", "italic", "text-sm", "uppercase"],
      secondary: ["text-medium"],
      tertiary: ["text-medium"]
    }
  },
  compoundVariants: [
    {
      isUnderline: !1,
      isUnderlineOnHover: !0,
      level: "primary",
      class: ["after:bottom-[-3px]", "hover:after:scale-x-100"]
    },
    {
      isUnderline: !1,
      isUnderlineOnHover: !0,
      level: "secondary",
      class: ["hover:after:scale-x-100"]
    },
    {
      isUnderline: !1,
      isUnderlineOnHover: !0,
      level: "tertiary",
      class: ["after:scale-x-100", "hover:after:scale-x-0"]
    }
  ]
}), b = ({
  ariaLabel: s,
  children: n,
  className: l,
  count: e,
  href: t,
  isUnderline: o = !1,
  isUnderlineOnHover: i = !0,
  level: f = "primary",
  onClick: m,
  ...c
}) => {
  const r = !t;
  return /* @__PURE__ */ p(
    r ? "button" : x,
    {
      "aria-label": s,
      className: a({
        class: l,
        isUnderline: o,
        isUnderlineOnHover: i,
        level: f
      }),
      href: t,
      onClick: m,
      type: r ? "button" : void 0,
      ...c,
      children: [
        n,
        e >= 0 && /* @__PURE__ */ u(v, { className: "aspect-auto bg-neutral-200 h-[1.5rem] min-w-[1.5rem] not-italic px-2 text-neutral-900 text-[0.8rem] w-auto", children: e })
      ]
    }
  );
};
b.styles = a;
export {
  b as default
};
